import { render, staticRenderFns } from "./CellRendererDetailList.vue?vue&type=template&id=718d83d5&"
import script from "./CellRendererDetailList.vue?vue&type=script&lang=js&"
export * from "./CellRendererDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports